<template>
  <div class="page-container">
    <el-card class="box-card" :body-style="{ flex: 1, overflow: 'auto' }">
      <template #header>
        <div class="header">
          <div class="title">
            <i class="iconfont icon-ota-fuwuqi" style="color: rgb(46, 204, 113); margin-right: 8px;"></i>
            {{$t('pages.diskDetectionDetails')}}
          </div>
          <div>
            <el-button class="button" type="danger" size="small" @click="backToParent">{{$t('activity.detail.back')}}</el-button>
          </div>
        </div>
      </template>
      <div>
        <div class="stats-overview">
          <div class="stat-card equipment">
            <div class="stat-header">
              <div class="stat-icon health">
                <i class="iconfont icon-ota-jiqiren1" style="color: #D80C1E;"></i>
              </div>
              <!-- <div class="stat-title">{{$t('collect.diskCheckDetail.cpuStatus')}}</div> -->
            </div>
            <div class="stat-title">{{$t('collect.diskCheckDetail.deviceStatus')}}</div>
            <el-tag :type="getStatusType(robotDiskHealthDetail?.diskState)" size="small">
              <i :class="getStatusIcon(robotDiskHealthDetail?.diskState)"></i>
              {{ getStatusText(robotDiskHealthDetail?.diskState) }}
            </el-tag>
            <div class="stat-value equipment">MAC：{{ robotDiskHealthDetail?.osMac || $t('error.alarm.pendingReport')}}</div>
            <div class="stat-footer">{{$t('collect.diskCheckDetail.latestUpdateTime')}}：{{ robotDiskHealthDetail?.createTime }}</div>
          </div>
          <div class="stat-card health">
            <div class="stat-header">
              <div class="stat-icon health">
                <i class="iconfont icon-ota-cpu" style="color: rgb(155, 89, 182);"></i>
              </div>
              <!-- <div class="stat-title">{{$t('collect.diskCheckDetail.cpuStatus')}}</div> -->
            </div>
            <div class="stat-title">{{$t('collect.diskCheckDetail.cpuStatus')}}</div>
            <el-tag type="success">
              <i class="el-icon-success"></i>
              {{$t('common.constant.normal')}}
            </el-tag>
            <div class="stat-value health">{{ robotDiskHealthDetail?.osCpu?.split("|")[2] ? robotDiskHealthDetail.osCpu.split("|")[2] + '%' : '' }}</div>
            <div class="stat-footer">{{$t('collect.diskCheckDetail.cpuAverageUsage')}}</div>
          </div>
          <div class="stat-card warning">
            <div class="stat-header">
              <div class="stat-icon warning">
                <i class="iconfont icon-ota-neicun" style="color: rgb(243, 167, 91);"></i>
              </div>
              <!-- <div class="stat-title">{{$t('collect.diskCheckDetail.memoryStatus')}}</div> -->
            </div>
            <div class="stat-title">{{$t('collect.diskCheckDetail.memoryStatus')}}</div>
            <el-tag type="success">
              <i class="el-icon-success"></i>
              {{$t('common.constant.normal')}}
            </el-tag>
            <div class="stat-value warning">{{ robotDiskHealthDetail?.osMem?.split("|")[2] ? robotDiskHealthDetail.osMem.split("|")[0] + '%' : '' }}</div>
            <div class="stat-footer">{{$t('collect.diskCheckDetail.memoryUsageRate')}}</div>
          </div>
        
          <div class="stat-card danger">
            <div class="stat-header">
              <div class="stat-icon danger">
                <i class="iconfont icon-ota-fuwuqi" style="color: rgb(46, 204, 113);"></i>
              </div>
              <!-- <div class="stat-title">{{$t('collect.diskCheckDetail.diskSpace')}}</div> -->
            </div>
            <div class="stat-title">{{$t('collect.diskCheckDetail.diskSpace')}}</div>
            <el-tag type="success">
              <i class="el-icon-success"></i>
              {{$t('common.constant.normal')}}
            </el-tag>
            <div class="stat-value danger">{{robotDiskHealthDetail?.osDisk?.split("|")[2]}}</div>
            <div class="stat-footer">{{$t('collect.diskCheckDetail.diskUsageRate')}}</div>
          </div>
        
          <div class="stat-card unknown">
            <div class="stat-header">
              <div class="stat-icon unknown">
                <i class="iconfont icon-ota-exchange-alt" style="color: rgb(75 210 188);"></i>
              </div>
              <!-- <div class="stat-title">{{$t('collect.diskCheckDetail.ioPerformance')}}</div> -->
            </div>
            <div class="stat-title">{{$t('collect.diskCheckDetail.ioPerformance')}}</div>
            <el-tag type="success">
              <i class="el-icon-success"></i>
              {{$t('common.constant.normal')}}
            </el-tag>
            <div class="stat-value unknown">{{robotDiskHealthDetail?.osIo?.split("|")[1]}}</div>
            <div class="stat-footer">{{$t('collect.diskCheckDetail.iops')}}</div>
          </div>
        </div>
        <el-card class="detail-card" style="margin-top: 20px;">
          <div class="card-title">
            <span style="display: flex;align-items: center;">
              <i class="iconfont icon-ota-exchange-alt" style="color: rgb(75 210 188);margin-right: 12px;"></i>
              {{$t('collect.diskCheckDetail.diskIoPerformanceDetails')}}
            </span>
            <el-tag type="success" size="small" >
              <i class="el-icon-success"></i>
              {{$t('points.exchange.status')}}：{{$t('common.constant.normal')}}
            </el-tag>
          </div>
          <div class="hardware-info">
            <div class="hardware-item">
              <div class="hardware-label">
                <!-- <el-tag type="success"> -->
                  <i class="iconfont icon icon-ota-fuwuqi"></i>
                <!-- </el-tag> -->
                {{$t('collect.diskCheckDetail.diskDevice')}}
              </div>
              <div class="hardware-value">{{robotDiskHealthDetail?.osIo?.split("|")[0]}}</div>
              <div class="hardware-des">{{$t('collect.diskCheckDetail.mainStorageDevice')}}</div>
            </div>
            <div class="hardware-item">
              <div class="hardware-label">
                <!-- <el-tag type="success"> -->
                  <i class="iconfont icon icon-ota-gongyezujian-yibiaopan"></i>
                <!-- </el-tag> -->
                {{$t('collect.diskCheckDetail.transferRate')}}</div>
              <div class="hardware-value">{{robotDiskHealthDetail?.osIo?.split("|")[1]}}</div>
              <div class="hardware-des">{{$t('collect.diskCheckDetail.transfersPerSecond')}}</div>
            </div>
            <div class="hardware-item">
              <div class="hardware-label">
                <!-- <el-tag type="success"> -->
                <i class="iconfont icon icon-ota-shangchuan"></i>
                <!-- </el-tag> -->
                {{$t('collect.diskCheckDetail.readSpeed')}}</div>
              <div class="hardware-value">{{robotDiskHealthDetail?.osIo?.split("|")[2]}}</div>
              <div class="hardware-des">KB/S</div>
            </div>
            <div class="hardware-item">
              <div class="hardware-label">
                <!-- <el-tag type="success"> -->
                  <i class="iconfont icon icon-ota-xiazai" style="color: rgb(46, 204, 113);"></i>
                <!-- </el-tag> -->
                {{$t('collect.diskCheckDetail.writeSpeed')}}
              </div>
              <div class="hardware-value">{{robotDiskHealthDetail?.osIo?.split("|")[3]}}</div>
              <div class="hardware-des">KB/S</div>
            </div>
          </div>
        </el-card>
        <el-card class="detail-card" style="margin-top: 20px;">
          <div class="card-title">
            <span style="display: flex;align-items: center;">
              <i class="iconfont icon-ota-neicun" style="color: rgb(243, 167, 91);"></i>
              <!-- <i class="iconfont icon-ota-neicun" style="color: rgb(243, 167, 91);margin-right: 12px;"></i> -->
              {{$t('collect.diskCheckDetail.memoryMonitoringDetails')}}
            </span>
            <el-tag type="success" size="small" >
              <i class="el-icon-success"></i>
              {{$t('points.exchange.status')}}：{{$t('common.constant.normal')}}
            </el-tag>
          </div>
          <div class="hardware-info">
            <div class="hardware-item">
              <div style="display: flex; justify-content: space-between;">
                <div class="hardware-label">{{$t('collect.diskCheckDetail.systemMemoryUsageRate')}}</div>
                <div class="hardware-value">{{robotDiskHealthDetail?.osMem?.split("|")[0] ? robotDiskHealthDetail?.osMem?.split("|")[0] + '%' : ''}}</div>
              </div>
              <div class="hardware-des">{{$t('collect.diskCheckDetail.systemOverallMemoryUsage')}}</div>
              <el-progress style="margin-top: 40px;" :text-inside="true" :stroke-width="20" :percentage="robotDiskHealthDetail?.osMem?.split('|')[0]" status="success"></el-progress>
            </div>
            <div class="hardware-item">
              <div style="display: flex; justify-content: space-between;">
                <div class="hardware-label">{{$t('collect.diskCheckDetail.nodeHeapMemoryUsageRate')}}</div>
                <div class="hardware-value">{{robotDiskHealthDetail?.osMem?.split("|")[1] ? robotDiskHealthDetail?.osMem?.split("|")[1] + '%' : ''}}</div>
              </div>
              <!-- <div class="hardware-label">Node堆内存占用率</div>
              <div class="hardware-value">{{robotDiskHealthDetail?.osMem?.split("|")[1]}}%</div> -->
              <div class="hardware-des">{{$t('collect.diskCheckDetail.nodeJsHeapMemoryUsage')}}</div>
              <el-progress style="margin-top: 40px;" :text-inside="true" :stroke-width="20" :percentage="robotDiskHealthDetail?.osMem?.split('|')[1]" status="warning"></el-progress>
            </div>
            <div class="hardware-item">
              <div style="display: flex; justify-content: space-between;">
                <div class="hardware-label">{{$t('collect.diskCheckDetail.nodeSystemMemoryPercentage')}}</div>
                <div class="hardware-value">{{robotDiskHealthDetail?.osMem?.split("|")[2] ? robotDiskHealthDetail?.osMem?.split("|")[2] + '%' : ''}}</div>
              </div>
              <div class="hardware-des">{{$t('collect.diskCheckDetail.nodeJsSystemMemoryPercentage')}}</div>
              <el-progress style="margin-top: 40px;" :text-inside="true" :stroke-width="20" :percentage="robotDiskHealthDetail?.osMem?.split('|')[2]" status="success"></el-progress>
            </div>
          </div>
        </el-card>
        <el-card class="detail-card" style="margin-top: 20px;">
          <div class="card-title">
            <span style="display: flex;align-items: center;">
              <i class="iconfont icon-ota-cpu" style="color: rgb(155, 89, 182);margin-right: 12px;"></i>
              {{$t('collect.diskCheckDetail.cpuMonitoringDetails')}}
            </span>
            <el-tag type="success" size="small" >
              <i class="el-icon-success"></i>
              {{$t('points.exchange.status')}}：{{$t('common.constant.normal')}}
            </el-tag>
          </div>
          <div class="hardware-info">
            <div class="hardware-item">
              <div class="hardware-label">
                <i class="iconfont icon icon-ota-gongyezujian-yibiaopan"></i>
                {{$t('collect.diskCheckDetail.oneMinuteLoad')}}
              </div>
              <div class="hardware-value">{{robotDiskHealthDetail?.osCpu?.split("|")[0]?.split(",")?.[0]}}</div>
              <div class="hardware-des">{{$t('collect.diskCheckDetail.shortTermLoadIndicator')}}</div>
            </div>
            <div class="hardware-item">
              <div class="hardware-label">
                <i class="iconfont icon icon-ota-gongyezujian-yibiaopan"></i>
                {{$t('collect.diskCheckDetail.fiveMinuteLoad')}}
              </div>
              <div class="hardware-value">{{robotDiskHealthDetail?.osCpu?.split("|")[0]?.split(",")?.[1]}}</div>
              <div class="hardware-des">{{$t('collect.diskCheckDetail.mediumTermLoadIndicator')}}</div>
            </div>
            <div class="hardware-item">
              <div class="hardware-label">
                <i class="iconfont icon icon-ota-gongyezujian-yibiaopan"></i>
                {{$t('collect.diskCheckDetail.fifteenMinuteLoad')}}
              </div>
              <div class="hardware-value">{{robotDiskHealthDetail?.osCpu?.split("|")[0]?.split(",")?.[2]}}</div>
              <div class="hardware-des">{{$t('collect.diskCheckDetail.longTermLoadIndicator')}}</div>
            </div>
            <div class="hardware-item">
              <div class="hardware-label">
                <i class="iconfont icon icon-ota-connection" style="color: rgb(155, 89, 182);"></i>
                {{$t('collect.diskCheckDetail.systemCpuUsageRate')}}
              </div>
              <div class="hardware-value">{{robotDiskHealthDetail?.osCpu?.split("|")[2] ? robotDiskHealthDetail?.osCpu?.split("|")[2] + '%' : ''}}</div>
              <div class="hardware-des">{{$t('collect.diskCheckDetail.averageUsageRate')}}</div>
            </div>
          </div>
          <div class="hardware-info">
            <div class="hardware-item">
              <div class="hardware-label">
                <i class="iconfont icon icon-ota-cpu" style="color: rgb(155, 89, 182);"></i>
                {{$t('collect.diskCheckDetail.cpuUsage')}}
              </div>
              <div class="hardware-content">
                <div class="hardware-content-title">CPU1：</div>
                <div class="hardware-content-value">
                  <el-progress :stroke-width="12" :percentage="robotDiskHealthDetail?.osCpu?.split('|')[1]?.split(',')?.[0]"></el-progress>
                </div>
              </div>
              <div class="hardware-content">
                <div class="hardware-content-title">CPU2：</div>
                <div class="hardware-content-value">
                  <el-progress :stroke-width="12" :percentage="robotDiskHealthDetail?.osCpu?.split('|')[1]?.split(',')?.[1]"></el-progress>
                </div>
              </div>
              <div class="hardware-content">
                <div class="hardware-content-title">CPU3：</div>
                <div class="hardware-content-value">
                  <el-progress :stroke-width="12" :percentage="robotDiskHealthDetail?.osCpu?.split('|')[1]?.split(',')?.[2]"></el-progress>
                </div>
              </div>
              <div class="hardware-content">
                <div class="hardware-content-title">CPU4：</div>
                <div class="hardware-content-value">
                  <el-progress :stroke-width="12" :percentage="robotDiskHealthDetail?.osCpu?.split('|')[1]?.split(',')?.[3]"></el-progress>
                </div>
              </div>
            </div>
          </div>
        </el-card>
        <el-card class="detail-card" style="margin-top: 20px;">
          <div class="card-title">
            <span style="display: flex;align-items: center;">
              <i class="iconfont icon-ota-fuwuqi" style="color: rgb(46, 204, 113);margin-right: 12px;"></i>
              {{$t('collect.diskCheckDetail.diskSpaceMonitoringDetails')}}
            </span>
            <el-tag type="success" size="small" >
              <i class="el-icon-success"></i>
              {{$t('points.exchange.status')}}：{{$t('common.constant.normal')}}
            </el-tag>
          </div>
          <div class="hardware-info">
            <div class="hardware-item">
              <div class="hardware-label">{{$t('collect.diskCheckDetail.totalDiskSize')}}</div>
              <div class="hardware-value">{{robotDiskHealthDetail?.diskSummary?.totalSize}}</div>
              <div class="hardware-des">{{$t('collect.diskCheckDetail.totalDiskCapacity')}}</div>
            </div>
            <div class="hardware-item">
              <div class="hardware-label">{{$t('collect.diskCheckDetail.usedDiskSize')}}</div>
              <div class="hardware-value">{{robotDiskHealthDetail?.diskSummary?.usedSize}}</div>
              <div class="hardware-des">{{$t('collect.diskCheckDetail.usedDiskSpace')}}</div>
            </div>
            <div class="hardware-item">
              <div class="hardware-label">{{$t('collect.diskCheckDetail.diskUsageRate')}}</div>
              <div class="hardware-value">{{robotDiskHealthDetail?.diskSummary?.usagePercent}}</div>
              <div class="hardware-des">{{$t('collect.diskCheckDetail.diskSpaceUsageRatio')}}</div>
            </div>
          </div>
          <div class="hardware-info" v-if="robotDiskHealthDetail.diskPartitionList?.length > 1">
            <div class="hardware-item">
              <div class="hardware-label">
                <i class="iconfont icon icon-ota-fuwuqi" style="color: rgb(46, 204, 113)"></i>
                  磁盘分区详情
              </div>
              <el-table
                ref="filterTable"
                :data="robotDiskHealthDetail.diskPartitionList"
                style="width: 100%">
                <el-table-column
                  prop="mountPoint"
                  label="路径"
                >
                </el-table-column>
                <el-table-column
                  prop="totalSizeStr"
                  :label="$t('collect.diskCheckDetail.totalDiskSize')"
                >
                </el-table-column>
                <el-table-column
                  prop="usedSizeStr"
                  :label="$t('collect.diskCheckDetail.usedDiskSize')"
                >
                </el-table-column>
                <el-table-column
                  prop="usagePercent"
                  :label="$t('collect.diskCheckDetail.usedDiskSpace')"
                >
                  <template #default="{row}">
                    <el-progress :stroke-width="12" :percentage="row.usagePercentStr.replace('%', '')"></el-progress>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-card>
      </div>
    </el-card>
     <!-- <div class="dashboard-container">
      <div class="header">
        <div class="title">
          <i class="iconfont icon-ota-fuwuqi" style="color: rgb(46, 204, 113); margin-right: 8px;"></i>
          {{$t('pages.diskDetectionDetails')}}
        </div>
        <div class="content">
          <div><span style="font-size: 18px;font-weight: 600;">{{$t('collect.diskCheckDetail.macAddress')}}：</span>{{ robotDiskHealthDetail?.osMac }}</div>
          <div style="font-size: 14px;margin-top: 4px;margin-bottom: 4px;">{{$t('collect.diskCheckDetail.latestUpdateTime')}}：{{ robotDiskHealthDetail?.diskQueryTime }}</div>
        </div>
      </div>
    </div> -->

  </div>
</template>

<script>
import { common } from '../../common/mixin'
// import Table from '@/components/table/index'
import { reactive, toRefs } from '@vue/reactivity'

import { reqRobotDiskHealthDetail } from '@/api/upgrade'
import { useRoute, useRouter } from 'vue-router'
import { standard } from '@/common/constant';
import { useI18n } from 'vue-i18n'
import { computed, onMounted } from "vue";
import { useStore } from "vuex"
export default {
  components: {},
  mixins: [common],
  setup () {
    const store = useStore()
    const { t } = useI18n()
    const route = useRoute()
    const router = useRouter()
    const robotId = route.query.robotId
    const userInfo = window.localStorage.getItem('userInfo')
    const state = reactive({
      params: [],
      standard: standard,
      userInfo: userInfo ? JSON.parse(userInfo) : {},
      curLang: computed(() => store.state.lang),
      robotDiskHealthDetail: {}
    })
 
    const searchData = async () => {
      const params = {id: robotId}
      reqRobotDiskHealthDetail(params).then(res => {
        state.robotDiskHealthDetail = res
      })
    }

    const backToParent = () => {
      router.back()
    }

    const getStatusType = (status) => {
      const typeMap = {
        HEALTHY: 'success',
        WARNING: 'warning',
        DANGER: 'danger',
        UNKNOWN: 'info'
      }
      return typeMap[status] || 'info'
    }
    const getStatusText = (status) => {
      const textMap = {
        HEALTHY: t('collect.diskCheck.health'),
        WARNING: t('error.alarm.warning'),
        DANGER:  t('collect.diskCheck.danger'),
        UNKNOWN: t('collect.diskCheck.unknown')
      }
      return textMap[status] || t('collect.diskCheck.unknown')
    }
    const getStatusIcon = (status) => {
      const textMap = {
        HEALTHY: 'el-icon-success',
        WARNING: 'el-icon-warning',
        DANGER: 'el-icon-error',
        UNKNOWN: 'el-icon-question'
      }
      return textMap[status] || 'el-icon-question'
    }
    onMounted(() => {
      searchData()
    })
    return {
      ...toRefs(state),
      searchData,
      backToParent,
      getStatusType,
      getStatusText,
      getStatusIcon
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.box-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  z-index: 10;
}
.card-header {
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  margin-bottom: 32px;
  // padding: 15px 20px;
  // background-color: #fff;
  border-radius: 4px;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #9e9e9e73;
}
.dashboard-container {
  
}
.header {
  // margin-bottom: 32px;
  // padding: 15px 20px;
  // background-color: #fff;
  // border-radius: 4px;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
   // display: flex;
  // justify-content: space-between;
  // align-items: center;
  // border-bottom: 1px solid #9e9e9e73;
}
.header .title {
  display: flex;
  color: #303133;
  font-size: 20px;
  font-weight: 500;
  align-items: center;
}
.stats-overview {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
}
.stat-card {
  flex: 1;
  min-width: 200px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  transition: all 0.3s;
}
.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
}
.stat-card.equipment {
  border-top: 4px solid #D80C1E;
}
.stat-card.health {
  border-top: 4px solid rgb(155, 89, 182);
}
.stat-card.warning {
  border-top: 4px solid rgb(243, 167, 91);
}
.stat-card.danger {
  border-top: 4px solid rgb(46, 204, 113);
}
.stat-card.unknown {
  border-top: 4px solid rgb(75 210 188);
}
.stat-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  justify-content: center;
}
.stat-icon {
  // width: 40px;
  // height: 40px;
  // border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.stat-icon.health {
  // background-color: #f0f9eb;
  // color: #67c23a;
}
.stat-icon.warning {
  // background-color: #fdf6ec;
  // color: #e6a23c;
}
.stat-icon.danger {
  // background-color: #fef0f0;
  // color: #f56c6c;
}
.stat-icon.unknown {
  // background-color: #f4f4f5;
  // color: #909399;
}
.stat-title {
  // color: #606266;
  font-size: 16px;
  font-weight: 600;
  margin: 8px 0px;
}
.stat-value {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin: 24px 0px 8px;
}
.stat-value.equipment {
  color: #D80C1E;
  font-size: 18px;
}
.stat-value.health {
  color: rgb(155, 89, 182);
}
.stat-value.warning {
  color: rgb(243, 167, 91);
}
.stat-value.danger {
  color: rgb(46, 204, 113);
}
.stat-value.unknown {
  color: rgb(75 210 188);
}
.stat-footer {
  text-align: center;
  font-size: 14px;
  color: #909399;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #606266;
}

.detail-grid {
  background-color: #fff;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.detail-card {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  // padding: 20px;
}

.hardware-info {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
}

.hardware-item {
  flex: 1;
  min-width: 120px;
  padding: 24px;
  border: 1px solid #e2d4d4ba;
  border-radius: 4px;
  text-align: left;
  // box-shadow: 0 2px 12px 0 rgb(158 158 158 / 26%);
}

.hardware-label {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-regular);
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.hardware-value {
  font-size: 32px;
  font-weight: 600;
}

.hardware-des {
  margin-top: 8px;
  margin-bottom: 12px;
  font-size: 14px;
  color: #909399;
}

.hardware-content {
  display: flex;
  line-height: 36px;
  align-items: center;
}
.hardware-content-title {
  width:55px
}
.hardware-content-value {
  width:calc(100% - 55px)
}

.iconfont {
  font-size: 48px;
  color: #666;
  margin-right: 0px;
}

.icon {
  font-size: 24px;
  color: rgb(46, 204, 113);
  margin-right: 8px;
}

::v-deep(.el-progress-circle_track) {
  color: aquamarine;
}

::v-deep(.el-table th) {
  background-color: #f8f9fa;
  padding: 18px 0px;
  font-weight: 600;
  color: #2c3e50;
  border-bottom: 2px solid #ecf0f1;
}

</style>
